import React from 'react';
import useTranslate from '../../../../Hooks/useTranslate';
import { Paper, Typography, useTheme } from '@mui/material';
import { FullSizeColumn, FlexBox } from '../../../../Components/FlexBox';
import DonutChart from '../../../../Components/Charts/DonutChart';
import GraphsLegend from '../../../../Components/Charts/GraphsLegend';

// mode: 'filters' | 'outcomes'
const SectionDonutPaper = function SectionDonutPaper({
  filterDetails = [],
  outcomeCounters = [],
  mode = 'filters',
}) {
  const translate = useTranslate();
  const theme = useTheme();

  const isFilters = mode === 'filters';

  const rawData = isFilters ? filterDetails : outcomeCounters;

  // filterDetails uses filterName; outcomeCounters uses name
  const colorKeys = rawData.map((d) => (isFilters ? d?.filterName : d?.name));
  const colors = theme.custom.generateConsistentUniqueColors(colorKeys);

  const donutData = rawData.map((item, index) => ({
    id:
      translate(isFilters ? item.filterName : item.name) ??
      translate('UNKNOWN'),
    value: item.count,
    color: colors[index],
  }));

  const donutTotal = donutData.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <Paper sx={{ padding: '16px', width: '65%', flexGrow: 0 }}>
      <FullSizeColumn gap="16px">
        <Typography variant="h6" sx={{ fontSize: '24px' }}>
          {translate(isFilters ? 'SCOPE_DETAILS' : 'CALL_OUTCOMES')}
        </Typography>
        <FlexBox
          padding="16px 24px"
          gap="36px"
          alignItems="center"
          flexGrow={1}
        >
          <DonutChart
            dataToShow={donutData}
            total={donutTotal}
            width={400}
            height={300}
            themeMode="light"
          />
          <GraphsLegend
            legendData={donutData?.map(({ id, value }) => `${id}: ${value}`)}
            legendColor={donutData.map(
              (item) => item.color[theme.palette.mode]
            )}
            height={300}
            scroll
          />
        </FlexBox>
      </FullSizeColumn>
    </Paper>
  );
};

export default SectionDonutPaper;
